var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CarouselComponent'),_c('HomeDividerText'),_c('HomeCards'),_c('Footer'),_c('Popup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }